/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../core/Error.js";
import { isSome as r } from "../../core/maybe.js";

function t() {
  return Promise.all([import("../webgl.js"), import("./mapViewDeps.js")]);
}

var s = function s() {
  return t().then(function () {
    return import("./layers/TileLayerView2D.js");
  });
},
    a = function a() {
  return t().then(function () {
    return import("./layers/FeatureLayerView2D.js");
  });
},
    i = {
  "base-dynamic": function baseDynamic() {
    return t().then(function () {
      return import("./layers/BaseDynamicLayerView2D.js");
    });
  },
  "base-tile": s,
  "bing-maps": s,
  csv: a,
  "geo-rss": function geoRss() {
    return t().then(function () {
      return import("./layers/GeoRSSLayerView2D.js");
    });
  },
  feature: a,
  geojson: a,
  graphics: function graphics() {
    return t().then(function () {
      return import("./layers/GraphicsLayerView2D.js");
    });
  },
  group: function group() {
    return t().then(function () {
      return import("./layers/GroupLayerView2D.js");
    });
  },
  imagery: function imagery() {
    return t().then(function () {
      return import("./layers/ImageryLayerView2D.js");
    });
  },
  "imagery-tile": function imageryTile() {
    return t().then(function () {
      return import("./layers/ImageryTileLayerView2D.js");
    });
  },
  kml: function kml() {
    return t().then(function () {
      return import("./layers/KMLLayerView2D.js");
    });
  },
  "map-image": function mapImage() {
    return t().then(function () {
      return import("./layers/MapImageLayerView2D.js");
    });
  },
  "map-notes": function mapNotes() {
    return t().then(function () {
      return import("./layers/MapNotesLayerView2D.js");
    });
  },
  "ogc-feature": function ogcFeature() {
    return t().then(function () {
      return import("./layers/OGCFeatureLayerView2D.js");
    });
  },
  "open-street-map": s,
  route: function route() {
    return t().then(function () {
      return import("./layers/RouteLayerView2D.js");
    });
  },
  stream: function stream() {
    return t().then(function () {
      return import("./layers/StreamLayerView2D.js");
    });
  },
  "subtype-group": function subtypeGroup() {
    return t().then(function () {
      return import("./layers/SubtypeGroupLayerView2D.js");
    });
  },
  tile: s,
  "vector-tile": function vectorTile() {
    return t().then(function () {
      return import("./layers/VectorTileLayerView2D.js");
    });
  },
  wcs: function wcs() {
    return t().then(function () {
      return import("./layers/ImageryTileLayerView2D.js");
    });
  },
  "web-tile": s,
  wfs: a,
  wms: function wms() {
    return t().then(function () {
      return import("./layers/WMSLayerView2D.js");
    });
  },
  wmts: function wmts() {
    return t().then(function () {
      return import("./layers/WMTSLayerView2D.js");
    });
  },
  analysis: null,
  "base-elevation": null,
  "building-scene": null,
  elevation: null,
  "integrated-mesh": null,
  "point-cloud": null,
  voxel: null,
  scene: null,
  unknown: null,
  unsupported: null
};

function o(r) {
  var t = r.declaredClass ? r.declaredClass.slice(r.declaredClass.lastIndexOf(".") + 1) : "Unknown",
      s = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
  return new e("".concat(s, ":view-not-supported"), "".concat(t, " is not supported in 2D"));
}

var l = {
  hasLayerViewModule: function hasLayerViewModule(e) {
    return r(i[e.type]);
  },
  importLayerView: function importLayerView(e) {
    var t = i[e.type];
    if (!r(t)) throw o(e);
    return t(e);
  }
};
export { l as layerView2DImporter };